export default __webpack_public_path__ + "static/media/BACKGROUNDcc 1.4133a33e.png";